import withAPIAction from 'utils/withAPIAction'
import { createDataAction } from './actions'
import { CreateDataReq } from './types'

import { verifyReqNoProject } from 'utils/verify'

export const sendReportDate = (token: string, data: CreateDataReq) => {
  const isValid = verifyReqNoProject(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<CreateDataReq>({
    method: 'POST',
    path: 'SendAutomail',
    data,
    token: `Bearer ${token}`,
  })(createDataAction)
}
